import { Action } from '@ngrx/store';
import { type } from '../../shared';

export const pdfAzureActionTypes = {
  ADD: type('[pdfAzure] Add'),
  ADD_SHIPPING: type('[pdfAzure] Add shipping'),
  ADD_SUCCESS: type('[pdfAzure] Add Success'),
  ADD_FAIL: type('[pdfAzure] Add Fail'),
  REMOVE_CLEAR: type('[pdfAzure] cleared'),
};

export class PdfAzure implements Action {
  readonly type = pdfAzureActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class PdfAzureShipping implements Action {
  readonly type = pdfAzureActionTypes.ADD_SHIPPING;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class PdfAzureSuccess implements Action {
  readonly type = pdfAzureActionTypes.ADD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class PdfAzureFail implements Action {
  readonly type = pdfAzureActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}

export class ClearPdfAzureAction implements Action {
  readonly type = pdfAzureActionTypes.REMOVE_CLEAR;
  constructor() {}
}
